import React, { useEffect, useRef, useState } from "react";

const ProductUnitPriceInput = ({
  value,
  onCommit,
  onFocusAttempt,
  autoFocus = false,
  readOnly = false,
}) => {
  const inputRef = useRef(null);
  const [localValue, setLocalValue] = useState(String(value ?? 0));
  const [isEditing, setIsEditing] = useState(false);

  useEffect(() => {
    if (!isEditing) {
      setLocalValue(String(value ?? 0));
    }
  }, [value, isEditing]);

  useEffect(() => {
    if (autoFocus && inputRef.current) {
      inputRef.current.focus();
      inputRef.current.select();
    }
  }, [autoFocus]);

  const commitValue = () => {
    const parsed = localValue.trim() === "" ? 0 : Number(localValue);
    onCommit(Number.isFinite(parsed) ? parsed : 0);
    setIsEditing(false);
  };

  const displayValue = isEditing
    ? localValue
    : Number(value ?? 0).toLocaleString();

  return (
    <input
      ref={inputRef}
      type="text"
      inputMode="numeric"
      readOnly={readOnly}
      className="product-unit-price-input product-highlight-value"
      value={displayValue}
      onFocus={(event) => {
        if (readOnly) {
          event.target.blur();
          return;
        }

        if (onFocusAttempt && !onFocusAttempt()) {
          event.target.blur();
          return;
        }

        setIsEditing(true);
        setLocalValue(String(value ?? 0));
        event.target.select();
      }}
      onChange={(event) => {
        setLocalValue(event.target.value.replace(/\D/g, ""));
      }}
      onBlur={commitValue}
      onKeyDown={(event) => {
        if (event.key === "Enter") {
          event.target.blur();
        }
      }}
    />
  );
};

export default ProductUnitPriceInput;
